/**
 * Auth API endpoints
 */

import { fetchApi } from '../core';
import type { PlatformRole, RegisterData, TenantMembershipResponse, TenantSelectionResponse } from '../types';
import type { Role } from '@/types';

interface AuthMessageResponse {
  message?: string;
}

interface AuthUserResponse {
  token: string;
  id: string;
  name: string;
  email: string;
  roles: Role[];
  platform_roles: PlatformRole[];
}

export function login(email: string, password: string, componentName: string = 'Unknown') {
  return fetchApi<AuthUserResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
    requireAuth: false
  }, componentName);
}

export function logout(componentName: string = 'Unknown') {
  return fetchApi('/auth/logout', {
    method: 'POST'
  }, componentName);
}

export function register(data: RegisterData, componentName: string = 'Unknown') {
  return fetchApi<AuthUserResponse>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(data),
    requireAuth: false
  }, componentName);
}

export function listTenants(componentName: string = 'Unknown') {
  return fetchApi<TenantMembershipResponse[]>('/auth/tenants', {}, componentName);
}

export function selectTenant(tenantId: string, componentName: string = 'Unknown') {
  return fetchApi<TenantSelectionResponse>(`/auth/tenants/${tenantId}/select`, {
    method: 'POST',
  }, componentName);
}

export function requestPasswordReset(email: string, componentName: string = 'Unknown') {
  return fetchApi<AuthMessageResponse>('/auth/request-password-reset', {
    method: 'POST',
    body: JSON.stringify({ email }),
    requireAuth: false
  }, componentName);
}

export function resetPassword(token: string, password: string, componentName: string = 'Unknown') {
  return fetchApi<AuthMessageResponse>('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
    requireAuth: false
  }, componentName);
}
